export const API_URLS = {
    LEGACY: {
        RESET_PASSWORD: '/account/forgottenpassword',
        REGISTRATION: '/public-api/v1/candidate/account',
    },
    BFF: {
        REGISTRATION: '/rlac/login-registration-service/Candidate/Register',
        LOGIN: '/rlac/login-registration-service/Candidate/SignIn',
        APPLE_LOGIN: '/rlac/login-registration-service/oauth/Apple/SignIn',
        TOKEN: '/rlac/login-registration-service/Antiforgery/Token',
        RESET_PASSWORD: '/rlac/login-registration-service/Candidate/ResetPassword',
        GOOGLE_AUTH: '/rlac/login-registration-service/oauth/Google/register',
        VERIFY_ACCOUNT_EXISTS: '/rlac/login-registration-service/Candidate/VerifyAccountExists',
        SEND_PASSWORDLESS_LINK: '/rlac/login-registration-service/Passwordless/generate-passwordless-link',
        CHANGE_PRIVATE_RELAY_EMAIL: '/rlac/login-registration-service/Social/ChangePrivateRelayEmail',
        LINKEDIN_REGISTER: '/rlac/login-registration-service/oauth/LinkedIn/register',
    },
    ANALYTICS: {
        STANDARD_PARAMETERS: '/analytics/api/v2/tracking',
    },
    SHARED_ASSETS: {
        LOGO: (logoBrandName) => `/sharedassets/logo/core/${logoBrandName}/logo.svg`,
    },
    CANDIDATE_PROFILE: {
        LINKEDIN_IMPORT_PROFILE: '/candidate/profile/editor/api/v1/linkedin-auth',
    },
};
export const SCRIPT_URLS = {
    APPLE_AUTH: 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js',
};
//# sourceMappingURL=urls.js.map